window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.casinoSkrivenNadimakRepo = function () {
    
    var set = function (skrivenNadimak) {
        var url = 'api/casinoigracskrivennadimak?skrivenNadimak=' + skrivenNadimak;
        return fetch(url, {
            method: 'POST',
            credentials: repos.base.credentials,
            headers: repos.base.headers()
        })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        set: set
    }
}();